
import React from "react";
import SearchBar from "./SearchBar";
import CategoryFilter from "./CategoryFilter";
import { FeedbackCategoryTag } from "@/types/feedback";

interface FilterControlsProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  categoryFilter: FeedbackCategoryTag;
  setCategoryFilter: (category: FeedbackCategoryTag) => void;
}

const FilterControls: React.FC<FilterControlsProps> = ({
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
}) => {
  const clearFilters = () => {
    setSearchTerm("");
    setCategoryFilter(null);
  };

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <SearchBar 
        searchTerm={searchTerm} 
        setSearchTerm={setSearchTerm} 
      />
      
      <CategoryFilter
        categoryFilter={categoryFilter}
        setCategoryFilter={setCategoryFilter}
        searchTerm={searchTerm}
        clearFilters={clearFilters}
      />
    </div>
  );
};

export default FilterControls;
